module.exports = __webpack_public_path__ + "static/media/react.797af278.jpg";